import { Button } from "antd";
import styled from "styled-components";
import { ReactSVG } from "react-svg";

export const Container = styled.div`
  padding: 20px 0px;
  display: flex;
  flex-direction: column;
  background-color: #e6e6e6;
  padding-top: 120px;
  min-height: 100vh;
`;

export const Title = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background-color: #e6e6e6;
  z-index: 1000;
  padding: 20px 0;
`;

export const NotificationsSubtitle = styled.div`
  color: ${({ theme: { colors } }) => colors.grayColors.gray};
  font-size: 24px;
  margin-left: 5px;
  line-height: 42px;
`;

export const NotificationButtonWrapper = styled.div`
  background-color: transparent;
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: -10px;
`;

export const NotificationButtonMain = styled(Button)`
  &.ant-btn {
    background-color: transparent;
    color: ${({ theme: { colors } }) => colors.grayColors.gray};
    display: flex;
    align-items: center;
    outline: none;
    border: none;
    box-shadow: none;
    /* margin: 5px -80px 0 40px; */
    margin: 5px -40px 0px 0px;

    div {
      display: flex;
    }

    span {
      margin-left: 8px;
    }
  }
`;

export const StyledTrashCanMain = styled(ReactSVG)`
  cursor: pointer;
  display: inherit;
  color: ${({ theme: { colors } }) => colors.grayColors.mediumGray};
`;

export const NotificationsWrapper = styled.div`
  background-color: #e6e6e6 !important;
  flex-wrap: wrap;
  flex-direction: row;
  display: inline-flex;
  justify-content: center;
  gap: 20px;
  align-content: baseline;
  width: 100%;
  height: calc(100vh - 280px);
  overflow-y: auto;
  padding: 20px;
  margin-bottom: 55px;
`;

export const NotificationPanel = styled.div`
  background-color: ${({ theme: { colors } }) => colors.mainColors.white};
  color: ${({ theme: { colors } }) => colors.mainColors.black};
  font-size: 14px;
  width: 85%;
  min-height: 140px;
  border-radius: 10px;
  box-shadow: 10px 10px 5px rgb(0 0 0/ 0.04);
  display: flex;
  flex-direction: column;
  position: relative;
`;

export const NotificationHeader = styled.div`
  border-radius: 10px 10px 0px 0px;
  height: 15px;
`;

export const NotificationContent = styled.div`
  margin: 10px;
  padding: 10px;
  flex: 1;
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-word;
`;

export const NotificationFooter = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
`;

export const CreatedTime = styled.div`
  color: ${({ theme: { colors } }) => colors.grayColors.mediumGray};
  font-size: 14px;
`;

export const NotificationButton = styled(Button)`
  &.ant-btn {
    background-color: ${({ theme: { colors } }) => colors.mainColors.white};
    color: ${({ theme: { colors } }) => colors.grayColors.gray};
    box-shadow: 10px 10px 5px rgb(0 0 0/ 0.04);
    display: flex;
    padding: 8px 15px;
    align-items: center;
    outline: none;
    border: none;

    div {
      display: flex;
    }

    span {
      margin-left: 8px;
    }
  }
`;

export const StyledTrashCan = styled(ReactSVG)`
  cursor: pointer;
  display: inherit;
  color: ${({ theme: { colors } }) => colors.grayColors.mediumGray};
  margin-top: 2.5px;
`;
